import { Request, Response } from "@konv/http";

import { OlgaRequest } from "./OlgaRequest";
import { EnvironmentStorage } from "shared/tools/EnvironmentStorage";
import { EnvironmentsAPI } from "./EnvironmentsAPI";

export class ClubAPI {
  static async foodRequest({
    endpoint = "/",
    method = "GET",
    headers = {},
    query = {},
    data = {},
  }) {
    return await Request.request({
      endpoint: endpoint,
      cors: true,
      method: method || "GET",
      headers: headers || {},
      service: "customers",
      ignoreVersion: true,
      params: query || {},
      data: data || {},
    });
  }

  static async foodRequestAuthenticated({
    endpoint = "/",
    method = "GET",
    query,
    data,
    customer,
  }) {
    const customerPhone = customer?.phone || null;
    if (!customerPhone) {
      return new Response(null, 403, ["Usuário não definido!"]);
    }

    const environment = await EnvironmentStorage.getEnvironment();

    const brand = await EnvironmentsAPI.getS3Configurations(
      environment?.brand?.alias,
    );

    const keys = brand?.keys;

    if (!keys?.olga_api_key) {
      return new Response(null, 403, ["Chave não definida!"]);
    }

    const headers = {
      Authorization: "Bearer " + keys?.olga_api_key,
      "x-customer-phone": `55${String(customerPhone).replace(/[^0-9]/g, "")}`,
    };

    return await ClubAPI.foodRequest({
      endpoint,
      headers,
      method,
      query,
      data,
    });
  }

  static async request({
    service,
    endpoint = "/",
    method = "GET",
    headers = {},
    query = {},
    data = {},
    serviceEndpoint,
  }) {
    return await OlgaRequest.request({
      service: service || "benefits/standard",
      endpoint: endpoint,
      headers,
      method: method || "GET",
      data,
      params: query,
      ignoreVersion: true,
      serviceEndpoint,
    });
  }

  static async getCustomerInfos(customer) {
    const response = await ClubAPI.foodRequestAuthenticated({
      endpoint: "/olga/infos",
      customer,
    });
    return response.getData(null);
  }
}
